import { MessageCircle } from 'lucide-react';
import { useSettings } from '@/contexts/SettingsContext';
import { useLanguage } from '@/contexts/LanguageContext';

const WhatsAppButton = () => {
  const { getWhatsAppUrl } = useSettings();
  const { language } = useLanguage();
  
  const messages = {
    en: 'Hello, I would like to learn more about Velmont Society experiences.',
    pt: 'Olá, gostaria de saber mais sobre as experiências da Velmont Society.',
    es: 'Hola, me gustaría saber más sobre las experiencias de Velmont Society.',
    fr: 'Bonjour, je voudrais en savoir plus sur les expériences Velmont Society.'
  };
  
  const whatsappUrl = getWhatsAppUrl(messages[language] || messages.en);

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-button"
      className="fixed bottom-8 right-8 z-50 group"
      aria-label="Contact us on WhatsApp"
    >
      <div className="relative">
        {/* Pulse animation */}
        <div className="absolute inset-0 bg-gold rounded-full animate-ping opacity-20" />
        
        {/* Button */}
        <div className="relative bg-gold hover:bg-gold-light text-black p-4 rounded-full shadow-[0_0_40px_-10px_rgba(212,175,55,0.4)] transition-all duration-300 group-hover:scale-110">
          <MessageCircle size={24} strokeWidth={2} />
        </div>
      </div>
      
      {/* Tooltip */}
      <span className="absolute right-full mr-4 top-1/2 -translate-y-1/2 bg-obsidian-paper border border-white/10 text-[#F5F5F0] text-xs px-4 py-2 whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
        Chat with us
      </span>
    </a>
  );
};

export default WhatsAppButton;
